<a
  [routerLink]="
    '/' + (settings.ClientId == 4 ? property.LongUrl : 'hotell/' + property.Url)
  "
  class="hotel"
  [target]="fromMap ? '_blank' : ''"
>
  <div class="image-container">
    <div class="image-wrapper">
      @if (property.TopMedia && property.TopMedia.Url) {
        <img
          [src]="
            property.TopMedia.Url
              | apiImage: 305 : property.TopMedia : 'fill' : 305
          "
          [alt]="property.Name"
          loading="lazy"
          [height]="305"
          [width]="305"
        />
      }
      @if (property.OverallRating && property.OverallRating > 0) {
        <div
          class="c-rating"
          matTooltip="Basert på {{ property.NumberOfReviews }} vurderinger"
        >
          {{ property.OverallRating.toFixed(1) }}
        </div>
      }
    </div>
    <!-- @if (property.Rating > 0) {
          <div class="ribbon">
            <span>
              @for (1 of getRating(property.Rating); track $index) {
                <span>★</span>
              }
            </span>
          </div>
        } -->
  </div>
  <div class="content">
    @if (!fromMap) {
      <span>
        @for (1 of getRating(property.Rating); track $index) {
          <span>★</span>
        }
      </span>
      @if (property.Location.City?.Name) {
        <div class="location">{{ property.Location.City?.Name }}</div>
      }
    }
    <div class="name">
      {{ property.Name }}
    </div>
    @if (showShortDescriptionText) {
      <div class="description">
        {{ property.ShortDescription }}
      </div>
    }
  </div>
</a>
